/*! Albatross (C) GrandPad, Inc */

import * as email_html from './email.html';
import {ValidationUtilsMixin} from '../../shared/mixins/validation-utils-mixin';

export default ValidationUtilsMixin.extend({

	render: email_html.render,
	staticRenderFns: email_html.staticRenderFns,

	components: {
		'gp-nav-buttons': () => import('../../shared/components/nav-buttons')
	},

	props: {
		existingEmail: {
			type: String,
			required: false
		}
	},

	data: function ()
	{
		return {
			email: null as string | null
		};
	},

	watch: {
		email: {
			handler ()
			{
				this.validateForm(true);
			}
		}
	},

	created ()
	{
		if (this.existingEmail)
		{
			this.email = this.existingEmail;
		}
	},

	methods: {
		onClickBack: function ()
		{
			this.$emit('back');
		},

		onClickSubmit: function ()
		{
			this.validateForm(false).then((valid) =>
			{
				if (valid)
				{
					this.$emit('submitEmail', this.email);
				}
			});

		}


	}
})
;
